import { Container, Nav, Tab } from "react-bootstrap";
import React, { useState, useEffect, useReducer } from "react";
import { useTranslation } from 'react-i18next';
import PageTitle from '../pageTitle/template_01';
import VIPContainer from '../../dynamic_section/dynamic_2/template_01';
import { Link, NavLink, useNavigate, useLocation } from "react-router-dom";
import { useMediaQuery } from 'react-responsive';

import "./template_01.css";


const VIP_ACTION = {
  SET_DEFAULT_VIP_TABS: 'SET_DEFAULT_VIP_TABS',
  SET_VIP_TABS: 'SET_VIP_TABS',
  SET_SELECTED_VIP_TAB: 'SET_SELECTED_VIP_TAB',
}

const initialVipData = {
  vipTabs: [
    { code: "ABOUTUS", name: "vip_about_us", toggle: "aboutUsToggle", imageName: 'vip_aboutUs' },
    { code: "FAQ", name: "vip_faq", toggle: "faqToggle", imageName: 'vip_faq' },
    { code: "TNC", name: "vip_tnc", toggle: "tncToggle", imageName: 'vip_tnc' },
    { code: "BENEFIT", name: "vip_benefit", toggle: "benefitToggle", imageName: 'vip_benefits' },
    { code: "REVIEW", name: "vip_review", toggle: "reviewToggle", imageName: 'vip_reviews' }
  ],

  selectedVipTab: { code: "ABOUTUS", name: "vip_about_us", toggle: "aboutUsToggle", imageName: 'vip_aboutUs' },
}

const vipReducer = (state, action) => {
  switch (action.type) {

    case VIP_ACTION.SET_VIP_TABS: {
      const vipTabs = action.payload
      return { ...state, vipTabs, selectedVipTab: vipTabs?.length > 0 ? { ...vipTabs[0] } : { code: "", name: "", toggle: "", imageName: '' } };
    }

    case VIP_ACTION.SET_SELECTED_VIP_TAB: {
      const selectedVipTab = state.vipTabs.find((vipTabs) => vipTabs.code === action.payload)
      return { ...state, selectedVipTab };
    }


    default: {
      throw new Error(`Unhandled action type: ${action.type}`)
    }
  }
}

const Vip = (props) => {
  const { t } = useTranslation();
  const { desktopToggle, mobileToggle, desktopBannerToggle, mobileBannerToggle, mode, ...tabProps } = props;
  const [vipState, vipDispatch] = useReducer(vipReducer, initialVipData)

  const onChangeVipTab = (newValue) => {
    vipDispatch({ type: VIP_ACTION.SET_SELECTED_VIP_TAB, payload: newValue })
  }

  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-width: 992px)'
  })

  // useEffect(() => {
  //   const getCurrentTab = vipState.defaultVipTabs.find(tab => tabProps[tab.toggle]);
  //   if (getCurrentTab) {
  //     vipDispatch({ type: VIP_ACTION.SET_VIP_TABS, payload: getCurrentTab });
  //   }
  // }, [vipState.defaultVipTabs, tabProps]);

  // function getCurrentTab(tabProps) {
  //   for (let i = 0; i < vipState.defaultVipTabs.length; i++) {
  //     if (tabProps[vipState.defaultVipTabs[i].toggle]) {
  //       return vipState.defaultVipTabs[i].code;
  //     }
  //   }
  //   return null;  
  // }
  // vipDispatch({ type: VIP_ACTION.SET_VIP_TABS, payload: getCurrentTab(tabProps) })


  if ((desktopToggle || mobileToggle) === true) {
    return (
      <section id="vip_01" className={`${desktopToggle ? "" : "d-lg-none"} ${mobileToggle ? "" : "d-none d-lg-block"}`}>
        <div className="vip_body">
          <PageTitle desktopToggle={false} mobileToggle={true} title={`vip`} id={'vip_title'} />
          <VIPContainer desktopToggle={desktopBannerToggle} mobileToggle={false} label={'vip_banner'} id={'vip_banner'} supportLanguage={true} />
          <VIPContainer desktopToggle={false} mobileToggle={mobileBannerToggle} label={'vip_banner'} id={'vip_banner_m'} supportLanguage={true} />

          <div className={`vip_container ${!isDesktopOrLaptop?'vip_container_m':''}`}>
            <div className="vipTabWrap">
              <div className="vipTab container">
              {vipState.vipTabs?.map(function (item, index) {
                if (tabProps[item.toggle]) {
                  if (mode === 'scroll') {
                    return (<a href={`#${item.code}`} key={item.code}>
                      <div className={`vipTab_selection ${item.code === vipState.selectedVipTab.code ? 'color_active active' : ''}`} key={`${item.code}`} onClick={() => onChangeVipTab(item.code)}>
                        {t(item.name)}
                      </div>
                    </a>)
                  } else {
                    return (<NavLink key={item.code} to={`#${item.code}`}>
                      <div className={`vipTab_selection ${item.code === vipState.selectedVipTab.code ? 'color_active active' : ''}`} key={`${item.code}`} onClick={() => onChangeVipTab(item.code)}>
                      {t(item.name)}
                      </div>
                    </NavLink>)
                  }

                }
                return null;

              })}
              </div>
              {/* {console.log('vipState.vipTabs',vipState.vipTabs)} */}
            </div>
            <div className="vip_tabContentContainer">
              {vipState.vipTabs?.map(function (item, index) {
                if (tabProps[item.toggle]) {
                  if (mode === 'scroll') {
                    return (<section key={item.name} id={item.code} className={`vip_scrollContent`}>
                      <VIPContainer desktopToggle={true} mobileToggle={false} label={`${item.name}`} id={`${item.imageName}`} supportLanguage={true} addContainer={true} />
                      <VIPContainer desktopToggle={false} mobileToggle={true} label={`${item.name}`} id={`${item.imageName}_m`} supportLanguage={true} addContainer={true} />
                    </section>)
                  } else {
                    return (<div key={item.name} className={`vip_tabContent  ${item.code === vipState.selectedVipTab.code ? 'd-block' : 'd-none'}`}>
                      <VIPContainer desktopToggle={true} mobileToggle={false} label={`${item.name}`} id={`${item.imageName}`} supportLanguage={true} addContainer={true} />
                      <VIPContainer desktopToggle={false} mobileToggle={true} label={`${item.name}`} id={`${item.imageName}_m`} supportLanguage={true} addContainer={true} />
                    </div>)
                  }

                }
                return null;

              })}
            </div>
          </div>


          {/* <Tab.Container defaultActiveKey="about_us">
            <Nav variant="pills" className="vipTab  container">
              <Nav.Item>
                <Nav.Link eventKey={'about_us'} className="vipTab_selection">
                  {t('vip_about_us')}
                </Nav.Link>
              </Nav.Item>
              <Nav.Item >
                <Nav.Link eventKey={'faq'} className="vipTab_selection">
                  {t('vip_faq')}
                </Nav.Link>
              </Nav.Item>
              <Nav.Item >
                <Nav.Link eventKey={'tnc'} className="vipTab_selection">
                  {t('vip_tnc')}
                </Nav.Link>
              </Nav.Item>
            </Nav>
            <Tab.Content className="vip_tabContent">
              <Tab.Pane eventKey="about_us">

                <Container className="vip_container">
                  <VIPContainer desktopToggle={true} mobileToggle={false} label={'vip aboutUs'} id={'vip_aboutUs'} supportLanguage={true} />
                  <VIPContainer desktopToggle={false} mobileToggle={true} label={'vip aboutUs'} id={'vip_aboutUs_m'} supportLanguage={true} />
                </Container>
              </Tab.Pane>
              <Tab.Pane eventKey="faq">

                <Container className="vip_container">
                  <VIPContainer desktopToggle={true} mobileToggle={false} label={'vip faq'} id={'vip_faq'} supportLanguage={true} />
                  <VIPContainer desktopToggle={false} mobileToggle={true} label={'vip faq'} id={'vip_faq_m'} supportLanguage={true} />
                </Container>
              </Tab.Pane>

              <Tab.Pane eventKey="tnc">
                <Container className="vip_container">
                  <VIPContainer desktopToggle={true} mobileToggle={false} label={'vip tnc'} id={'vip_tnc'} supportLanguage={true} />
                  <VIPContainer desktopToggle={false} mobileToggle={true} label={'vip tnc'} id={'vip_tnc_m'} supportLanguage={true} />
                </Container>
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container> */}
        </div>
      </section>
    );
  }
  else {

  }
}

export default Vip;
